import Image1 from "../../assets/dpk.jpg";
import Image2 from "../../assets/srya.jpg";
import Image3 from "../../assets/bpn.jpg";
import Image4 from "../../assets/testimonial1.png";
import Image5 from "../../assets/testimonial2.png";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "Deepak das",
    description:
      "Attention to detail and dedication were unmatched. Their high-quality work and proactive communication made the project a success.",
  },
  {
    id: 2,
    image: Image2,
    title: "Shreya Karki",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 3,
    image: Image3,
    title: "Bipin Giri",
    description:
      " professionalism and innovative solutions were invaluable. Highly recommended for any software development job.",
  },
  {
    id: 4,
    image: Image4,
    title: "Harry Clinton",
    description:
      "A really good job, all aspects of the project were followed step by step and with good results.",
  },
  {
    id: 4,
    image: Image5,
    title: "Sara Cill",
    description:
      "consistently impressed with expertise and problem-solving skills. It was a pleasure working",
  },
];
